import React from 'react'

export default () => (
  <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M8.57677 0C9.04409 0 9.42293 0.378836 9.42293 0.846154V18.688L15.5938 12.5171C15.9243 12.1866 16.46 12.1866 16.7905 12.5171C17.1209 12.8475 17.1209 13.3833 16.7905 13.7137L9.17509 21.3291C8.84465 21.6595 8.3089 21.6595 7.97845 21.3291L0.363067 13.7137C0.0326234 13.3833 0.0326234 12.8475 0.363067 12.5171C0.693511 12.1866 1.22927 12.1866 1.55971 12.5171L7.73062 18.688V0.846154C7.73062 0.378836 8.10945 0 8.57677 0Z" fill="#0082CA"/>
  </svg>

)
